import axios from "axios";

const token = JSON.parse(localStorage.getItem("token"));

export const publicApi = axios.create({
      baseURL: `${process.env.REACT_APP_SECRET_KEY}/api`,
      headers: {
            apikey: process.env.REACT_APP_LOCAL_URL,
      },
});

export const privateApi = axios.create({
      baseURL: `${process.env.REACT_APP_SECRET_KEY}/api`,
      headers: {
            Authorization: `Bearer ${token}`,
            apikey: process.env.REACT_APP_LOCAL_URL,
            "Content-Type": "multipart/form-data",
      },
});
